import { render, staticRenderFns } from "./announcementDetail.vue?vue&type=template&id=100e3169&scoped=true"
import script from "./announcementDetail.vue?vue&type=script&lang=js"
export * from "./announcementDetail.vue?vue&type=script&lang=js"
import style0 from "./announcementDetail.vue?vue&type=style&index=0&id=100e3169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100e3169",
  null
  
)

export default component.exports